/**
 * Extracts error message from various error formats, with special handling for policy errors
 * @param {Object} error - The error object (may be transformed or untransformed)
 * @returns {string|null} The extracted error message or null
 */
export const extractErrorMessage = (error) => {
  let message = null

  // Handle policy errors with base array format
  // Check for transformed format: { type: 'policy', payload: { base: [...] } }
  if (error?.type === 'policy' && Array.isArray(error?.payload?.base) && error.payload.base.length > 0) {
    message = error.payload.base[0]
  } else if (Array.isArray(error?.policy?.base) && error.policy.base.length > 0) {
    // Check for untransformed format: { policy: { base: [...] } } (when transformResponse: false)
    message = error.policy.base[0]
  } else if (error?.payload?.message !== undefined && error?.payload?.message !== null) {
    // Handle legacy format: { payload: { message: '...' } }
    message = error.payload.message
  } else if (error?.message !== undefined && error?.message !== null) {
    // Handle direct message format: { message: '...' }
    message = error.message
  }

  // Normalize policy error messages to match expected format
  if (message !== null && message !== undefined && error?.type === 'policy') {
    const normalizedMessage = message.trim()
    // If message is empty string, return as-is
    if (normalizedMessage === '') {
      return message === '' ? '' : '.'
    }
    // Ensure policy error messages end with a period
    if (!normalizedMessage.endsWith('.')) {
      return `${normalizedMessage}.`
    }
    return normalizedMessage
  }

  // Normalize payload.message to ensure it ends with a period (for legacy format)
  if (message !== null && message !== undefined && error?.payload?.message !== undefined && !message.endsWith('.')) {
    return `${message}.`
  }

  return message
}
